//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    text: {
      type: String,
      default:
        'BOMIST was purpose-built for the electronics manufacturing industry. Manage your inventory, BOMs, procurement and sales in one place.'
    }
  }
};
